(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.onScrollHandler();

      this.createObserver();

      this.querySelector('[data-product-link]')?.addEventListener('click', event => {
        const targetElement = document.querySelector('.product-purchase-card')

        if(targetElement && event.currentTarget.href === window.location.href) {
          event.preventDefault()

          targetElement.scrollIntoView({
            behavior: "smooth"
          });
        }
      })
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["listicle-naturlich"] && !Shopify.designMode) return;
  try {
    
/* Listicle: Aufbau-Animation des Vitamin-C-Visuals (einmal, sobald es knapp zur Hälfte im Bild ist) und Sprung-Buttons */
(function(){
  function init(root){
    root.querySelectorAll('.sn-listicle__balls:not(.sn-js)').forEach(function(el){
      var ziel=el.querySelector('.sn-listicle__card--nat svg');
      if(!ziel || !('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) return;
      el.classList.add('sn-js');
      new IntersectionObserver(function(e,o){ if(e[0].isIntersecting){ el.classList.add('is-in'); o.disconnect(); } },{threshold:.45, rootMargin:'0px 0px -10% 0px'}).observe(ziel);
    });
  }
  document.addEventListener('click',function(e){
    var a=e.target.closest && e.target.closest('.sn-listicle a[data-sn-ziel]');
    if(!a) return;
    var t=document.querySelector('[id*="'+a.getAttribute('data-sn-ziel')+'"]');
    if(t){ e.preventDefault(); window.scrollTo({top:t.getBoundingClientRect().top+window.scrollY-90, behavior:'smooth'}); }  /* 90 px Platz fuer die feste Kopfzeile */
  });
  init(document);
  document.addEventListener('shopify:section:load',function(e){ init(e.target); });
})();

/* Preis-Balken: Restbreite (Tropfen + Pille) messen, Balken wachsen lassen, sobald sie ins Bild kommen */
(function(){
  function messen(el){ el.querySelectorAll('.sn-fact').forEach(function(z){ var r=0; z.querySelectorAll('.sn-fact__drop,.sn-fact__value').forEach(function(t){ r+=parseFloat(getComputedStyle(t).marginLeft)+t.offsetWidth; }); z.style.setProperty('--rest',Math.round(r)+'px'); }); }
  function init(root){
    root.querySelectorAll('.sn-facts:not(.sn-js)').forEach(function(el){
      messen(el); if(window.ResizeObserver) new ResizeObserver(function(){ messen(el); }).observe(el);
      if(!('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) return;
      el.classList.add('sn-js');
      new IntersectionObserver(function(e,o){ if(e[0].isIntersecting){ requestAnimationFrame(function(){ el.classList.add('is-in'); }); o.disconnect(); } },{threshold:.5}).observe(el);
    });
  }
  init(document);
  document.addEventListener('shopify:section:load',function(e){ init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-wechseljahre"] && !Shopify.designMode) return;
  try {
    
/* Knopf mit Ziel "main_product": sanft zur Buy-Box scrollen (90 px Platz für die feste Kopfzeile) */
(function(){
  document.addEventListener('click',function(e){
    var a=e.target.closest && e.target.closest('.sn-wj a[data-sn-ziel]');
    if(!a) return;
    /* Ziel aus dem Feld; findet es nichts, die Buy-Box unter ihren üblichen Namen suchen */
    var t=document.querySelector('[id*="'+a.getAttribute('data-sn-ziel')+'"]')||document.querySelector('[id*="__main_product"],[id*="products_banner"]');
    if(t){ e.preventDefault(); window.scrollTo({top:t.getBoundingClientRect().top+window.scrollY-90, behavior:'smooth'}); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-umfrage"] && !Shopify.designMode) return;
  try {
    
/* PDP-Umfrage. Keine Namen, keine E-Mail. Merker im Browser, damit niemand zweimal gefragt wird; die Antwort steht
   zusätzlich als Merkmal im Shopify-Warenkorb (Fassung 2), damit sie bei einem Kauf in der Bestellung steht. */
(() => {
  // Speicher-Zugriff komplett im try: manche Browser sperren localStorage/sessionStorage schon beim Ansprechen
  const merken = (art, k, v) => { try { window[art].setItem(k, v); } catch (e) {} };
  const lesen = (art, k) => { try { return window[art].getItem(k); } catch (e) { return null; } };
  // Cookie-Banner von Pandectes noch offen? Dann warten, sonst liegen beide übereinander.
  const bannerOffen = () => {
    const r = document.querySelector('pandectes-cmp')?.shadowRoot;
    return !!r && [...r.querySelectorAll('button')].some(b => /akzeptieren|ablehnen/i.test(b.textContent) && b.getClientRects().length > 0);
  };
  const tiefe = () => (scrollY + innerHeight) / Math.max(document.documentElement.scrollHeight, 1);

  function start(el, imEditorZeigen) {
    if (el.dataset.umfStart) return;
    el.dataset.umfStart = '1';
    const d = el.dataset;
    const editor = d.editor === 'true';
    const q = new URLSearchParams(location.search);
    const test = !editor && q.get('umfrage') === 'test';
    const key = 'sn-umf-' + (d.runde || '1');
    const maus = matchMedia('(pointer:fine)').matches;
    let antwort = '', antwortId = '', nachfrage = '', gesendet = false, beantwortet = false, offen = false, aus = false, sekunden = 0, dankeUhr;

    // Herkunft: UTM aus der Adresse, sonst aus diesem Besuch, sonst die fremde Seite davor
    let utm = { source: q.get('utm_source') || (q.get('fbclid') ? 'facebook' : q.get('gclid') ? 'google' : ''), campaign: q.get('utm_campaign') || '', content: q.get('utm_content') || '' };
    if (utm.source || utm.campaign) merken('sessionStorage', 'sn-umf-utm', JSON.stringify(utm));
    else { try { utm = JSON.parse(lesen('sessionStorage', 'sn-umf-utm')) || utm; } catch (e) {} }
    if (!utm.source && document.referrer) { try { const h = new URL(document.referrer).hostname; if (h !== location.hostname) utm.source = h; } catch (e) {} }

    // Eine Zeile an Airtable. Airtable antwortet Browsern ohne CORS-Freigabe: sendBeacon schickt trotzdem ab und überlebt auch das Verlassen der Seite
    const zeile = (adresse, felder) => {
      if (editor || !adresse) return;
      const daten = new URLSearchParams(Object.assign(felder, { geraet: innerWidth < 750 ? 'Handy' : 'Desktop', quelle: utm.source || '',
        kampagne: utm.campaign || '', anzeige: utm.content || '', runde: d.runde || '', test: test ? 'ja' : 'nein' }));
      if (!(navigator.sendBeacon && navigator.sendBeacon(adresse, daten))) fetch(adresse, { method: 'POST', mode: 'no-cors', keepalive: true, body: daten }).catch(() => {});
    };
    // Antworten in AI_PDP_Umfrage, Ankünfte (Pop-up, Info; Seiten melden sich selbst) in AI_Einwand_Ankunft
    const schicken = felder => zeile(d.webhook, Object.assign({ antwort: '', nachfrage: '', seite: location.pathname, sekunden: '' }, felder));
    const ankunftSchicken = felder => zeile(d.webhookAnkunft, Object.assign({ antwort: '', ziel: '', infos: '', sekunden: '' }, felder));
    // Merkmal im Shopify-Warenkorb: steht bei einem Kauf in der Bestellung („Zusätzliche Details“)
    const warenkorb = merkmal => {
      if (editor) return;
      fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/update.js',
        { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: merkmal }), keepalive: true }).catch(() => {});
    };
    // Clarity zählt nur Besucher mit Cookie-Zustimmung und lädt erst danach: bis 10 s nachfassen, sonst still weglassen.
    // Im Testmodus heißen die Ereignisse test_…, damit Tests nicht mitzählen.
    const clarity = (args, n = 10) => {
      if (editor) return;
      if (typeof window.clarity === 'function') window.clarity(...args);
      else if (n) setTimeout(() => clarity(args, n - 1), 1000);
    };
    const ereignis = name => clarity(['event', (test ? 'test_' : '') + name]);
    // Überleitung in ein Pop-up dieser Seite: es öffnet sofort, deshalb zählt die Ankunft gleich hier (Seiten zählen sie selbst, Section einwand-ankunft).
    // Die Airtable-Zeile geht erst beim Schließen raus, mit den Sekunden, die das Pop-up offen war.
    const beimSchliessen = [];
    const ankunft = (popup, direkt = false) => {
      warenkorb({ zwischenseite: popup.replace(/^sn-/, '') });
      ereignis('einwand_ankunft');
      const wie = antwort, t0 = Date.now();
      let raus = false;
      // ponytail: Wer den Tab wechselt und zurückkommt, wird mit der Zeit bis zum Wechsel gezählt
      const melden = () => {
        if (raus) return;
        raus = true;
        ankunftSchicken({ antwort: wie, ziel: location.pathname + '#' + popup, sekunden: String(Math.round((Date.now() - t0) / 1000)) });
      };
      if (direkt) beimSchliessen.push(melden);
      else document.getElementById(popup).addEventListener('close', melden, { once: true });
      addEventListener('pagehide', melden);
      document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') melden(); });
    };
    // Pop-up-Inhalt direkt in der Karte (Haken „direkt“): einmal hineinkopiert, zählt wie das Öffnen des Pop-ups
    // ponytail: nimmt die erste Seite des Pop-ups; Pop-ups mit mehreren Seiten zum Wischen bräuchten mehr
    // Pop-up-Seite dieser Seite: ID eines Pop-ups (seine erste Seite) oder eines Elements in einer Seite (z. B. sn-benefit-energie)
    const popupSeite = id => { const e = id && document.getElementById(id); return e && (e.matches('dialog') ? e.querySelector('.sn-sheet__seite') : e.closest('.sn-sheet__seite')); };
    const einfuellen = (ziel, quelle) => {
      if (!ziel || !quelle || ziel.firstChild) return;
      const kopie = quelle.cloneNode(true);
      kopie.querySelectorAll('[id]').forEach(e => e.removeAttribute('id'));
      kopie.querySelector('h2')?.setAttribute('tabindex', '-1');
      ziel.append(kopie);
    };
    const direkt = id => {
      const s = el.querySelector(`[data-umf-schritt="direkt-${id}"]`);
      const quelle = s && popupSeite(s.dataset.umfDirekt);
      if (!quelle) return false;
      einfuellen(s.querySelector('[data-umf-direkt-inhalt]'), quelle);
      schritt('direkt-' + id);
      if (!editor && !s.dataset.gezaehlt) { s.dataset.gezaehlt = '1'; ankunft(s.dataset.umfDirekt, true); }
      return true;
    };
    // Info-Antwort in der Karte (3. Schritt) zählt ebenfalls wie eine Überleitung, einmal je Anzeige: Merkmal und Clarity beim
    // ersten Info, die Airtable-Zeile beim Schließen oder Verlassen, mit allen angesehenen Infos und den Sekunden seit dem ersten.
    let infoStart = 0, infoAntwort = '', optionenSchritt = 'frage', ersteRueck = null;
    const gesehen = [];
    const infoMelden = () => {
      if (infoStart <= 0) return;
      const s = String(Math.round((Date.now() - infoStart) / 1000));
      infoStart = -1;
      ankunftSchicken({ antwort: infoAntwort, ziel: location.pathname + '#info', infos: gesehen.join(', '), sekunden: s });
    };
    const info = option => {
      const ziel = [...el.querySelectorAll('[data-umf-info]')].find(i => i.dataset.umfInfo === option);
      if (!ziel) return false;
      // „← Zurück“ führt zu der Nachfrage, in der diese Antwort steht
      const knopf = [...el.querySelectorAll('[data-umf-nach]')].find(k => k.textContent.trim() === option);
      optionenSchritt = knopf ? knopf.closest('[data-umf-schritt]').dataset.umfSchritt : 'frage';
      const aus = ziel.querySelector('[data-umf-popup-inhalt]');
      if (aus) einfuellen(aus, popupSeite(aus.dataset.umfPopupInhalt));
      schritt(ziel.dataset.umfSchritt);
      if (editor) return true;
      if (!gesehen.includes(option)) gesehen.push(option);
      if (!infoStart) {
        infoStart = Date.now();
        infoAntwort = antwort;   // gilt auch, wenn danach noch eine andere Antwort gewählt wird
        warenkorb({ zwischenseite: 'info: ' + option });
        ereignis('einwand_ankunft');
        addEventListener('pagehide', infoMelden);
        document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') infoMelden(); });
      }
      return true;
    };

    const schritt = name => {
      const drin = el.contains(document.activeElement);
      let ziel;
      el.querySelectorAll('[data-umf-schritt]').forEach(s => { s.hidden = s.dataset.umfSchritt !== name; if (!s.hidden) ziel = s; });
      // Rückmeldung „Danke für dein Feedback …“ nur beim ersten Schritt mit Infos, nicht noch einmal auf dem nächsten
      const r = ziel && ziel.querySelector('[data-umf-rueck]');
      if (r) { ersteRueck = ersteRueck || r; r.hidden = r !== ersteRueck; }
      // Freitextfeld nur dann gleich anwählen, wenn es keine Antworten zum Antippen gibt
      if (drin && ziel) (maus && !ziel.querySelector('[data-umf-nach]') && ziel.querySelector('textarea') || ziel.querySelector('[tabindex="-1"]'))?.focus({ preventScroll: true });
    };
    const mischen = () => {
      const liste = el.querySelector('[data-umf-liste]'), unten = liste.querySelector('[data-unten]');
      const normal = [...liste.children].filter(b => !b.hasAttribute('data-unten'));
      for (let i = normal.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [normal[i], normal[j]] = [normal[j], normal[i]]; }
      normal.forEach(b => liste.insertBefore(b, unten));
    };
    const senden = () => {
      if (gesendet || !antwort) return;
      gesendet = true;
      schicken({ antwort, nachfrage, sekunden: String(sekunden) });
    };
    const zeigen = () => {
      if (offen || aus || (!test && !editor && bannerOffen())) return;
      offen = true;
      if (!editor) mischen();
      schritt('frage');
      el.hidden = false;
      ereignis('umfrage_angezeigt');
    };
    const verstecken = () => { el.hidden = true; offen = false; };
    const schliessen = () => {
      clearTimeout(dankeUhr);
      verstecken();
      if (editor) return;
      if (!beantwortet) ereignis('umfrage_geschlossen');
      senden();
      infoMelden();
      beimSchliessen.forEach(f => f());
      aus = true;
      if (!test) merken('localStorage', key, String(Date.now()));
    };
    const zurueck = () => { clearTimeout(dankeUhr); antwort = nachfrage = ''; ersteRueck = null; schritt('frage'); };
    const fertig = () => {
      const weiter = el.querySelector(`[data-umf-weiter="${antwortId}"]`);
      el.querySelectorAll('[data-umf-weiter]').forEach(w => { w.hidden = w !== weiter; });
      schritt('danke');
      // Mit Überleitung bleibt der Dank stehen, bis man weitergeht oder schließt
      if (!weiter) dankeUhr = setTimeout(editor ? zurueck : schliessen, 4000);
    };

    // Überleitung in ein Pop-up, das es auf dieser Seite nicht gibt: weglassen, dann gilt der normale Dank
    el.querySelectorAll('[data-umf-direkt]').forEach(s => { if (!document.getElementById(s.dataset.umfDirekt)) s.remove(); });
    el.querySelectorAll('[data-umf-weiter] [data-sn-sheet]').forEach(k => { if (!document.getElementById(k.dataset.snSheet)) k.closest('[data-umf-weiter]').remove(); });
    if (test) el.querySelectorAll('a[data-umf-weg]').forEach(a => { const u = new URL(a.href, location.href); u.searchParams.set('umfrage', 'test'); a.href = u; });

    // Gewählte Antwort färbt sich kurz, damit man sieht, was man getroffen hat; erst dann der nächste Schritt
    let klick;
    const waehlen = (b, weiter) => {
      if (klick) return;
      b.classList.add('sn-umf__antwort--gewaehlt');
      klick = setTimeout(() => { klick = null; b.classList.remove('sn-umf__antwort--gewaehlt'); weiter(); }, 180);
    };
    el.addEventListener('click', e => {
      const weg = e.target.closest('[data-umf-weg]');
      if (weg) {
        if (editor) { if (weg.tagName === 'A') e.preventDefault(); return; }
        ereignis('umfrage_weiter');
        if (weg.dataset.umfWeg) ankunft(weg.dataset.umfWeg);
        // Pop-up: öffnet danach popup-basis über data-sn-sheet. Link: der Browser folgt ihm von selbst.
        return schliessen();
      }
      const b = e.target.closest('button');
      if (!b) return;
      if (b.hasAttribute('data-umf-zu')) return schliessen();
      if (b.hasAttribute('data-umf-zurueck')) return zurueck();
      if (b.hasAttribute('data-umf-optionen')) return schritt(optionenSchritt);
      if (b.hasAttribute('data-umf-antwort')) {
        antwort = b.textContent.trim(); nachfrage = ''; antwortId = b.dataset.umfAntwort;
        if (!editor) {
          warenkorb({ einwand: antwort });
          merken('sessionStorage', 'sn-umf-antwort', antwort);
          merken('sessionStorage', 'sn-umf-runde', d.runde || '');
          clarity(['set', 'einwand', antwort]);
          if (!beantwortet) { beantwortet = true; ereignis('umfrage_beantwortet'); }
          // Wer geantwortet hat, wird in dieser Runde nicht mehr gefragt, auch wenn er die Karte nicht schließt
          if (!test) merken('localStorage', key, String(Date.now()));
        }
        return waehlen(b, () => el.querySelector(`[data-umf-schritt="${antwortId}"]`) ? schritt(antwortId) : (direkt(antwortId) || fertig()));
      }
      // Gibt es zu dieser Nachfrage-Antwort ein Info, beantwortet die Karte sie direkt (3. Schritt), sonst der Dank
      if (b.hasAttribute('data-umf-nach')) { nachfrage = b.textContent.trim(); waehlen(b, () => info(nachfrage) || fertig()); }
    });
    // Handy: Leiste nach unten wegwischen (nur wenn sie ganz oben steht, sonst scrollt man in ihr)
    const karte = el.querySelector('.sn-umf__karte');
    let startY = null, dy = 0;
    karte.addEventListener('touchstart', e => { startY = karte.scrollTop <= 0 ? e.touches[0].clientY : null; dy = 0; }, { passive: true });
    karte.addEventListener('touchmove', e => { if (startY === null) return; dy = Math.max(0, e.touches[0].clientY - startY); karte.style.transform = dy ? `translateY(${dy}px)` : ''; }, { passive: true });
    karte.addEventListener('touchend', () => { if (startY === null) return; startY = null; karte.style.transform = ''; if (dy > 80) schliessen(); });
    el.addEventListener('submit', e => { e.preventDefault(); nachfrage = e.target.querySelector('textarea').value.trim().slice(0, 500); fertig(); });
    el.addEventListener('keydown', e => { if (e.key === 'Escape') schliessen(); });

    if (editor) {
      // Im Theme-Editor nur sichtbar, solange die Section (oder eine ihrer Antworten) ausgewählt ist
      const meins = e => e.target.contains(el) || el.contains(e.target);
      document.addEventListener('shopify:section:select', e => { if (meins(e)) zeigen(); });
      document.addEventListener('shopify:section:deselect', e => { if (meins(e)) verstecken(); });
      document.addEventListener('shopify:block:select', e => {
        if (!meins(e)) return;
        zeigen();
        const id = e.detail && e.detail.blockId;
        if (!id) return;
        antwortId = id;
        const s = el.querySelector(`[data-umf-schritt="${id}"]`);
        if (s && s.dataset.umfInfo !== undefined) info(s.dataset.umfInfo);
        else if (s) schritt(id);
        else if (direkt(id)) return;
        else if (el.querySelector(`[data-umf-weiter="${id}"]`)) fertig();
      });
      if (imEditorZeigen) zeigen();
      return;
    }
    if (test) el.querySelector('[data-umf-test]').hidden = false;
    else {
      if (d.live !== 'true' || !d.webhook || d.kunde === 'true' || +d.warenkorb > 0) return;
      if (lesen('localStorage', key) || lesen('sessionStorage', 'sn-umf-pause')) return;
      // Wer kaufen will, wird nicht mehr gefragt
      const stopp = () => { aus = true; if (offen && !antwort) verstecken(); };
      document.addEventListener('submit', e => { if (e.target.matches('form[action*="/cart/add"]')) stopp(); }, true);
      document.addEventListener('click', e => { if (e.target.closest('[name="add"], a[href*="/cart"], a[href*="/checkout"], .shopify-payment-button')) stopp(); }, true);
      addEventListener('klaviyoForms', e => { if (e.detail && e.detail.type === 'open') { merken('sessionStorage', 'sn-umf-pause', '1'); stopp(); } });
      if (d.exit === 'true' && maus) document.addEventListener('mouseout', e => { if (!e.relatedTarget && e.clientY <= 0 && sekunden >= 10) zeigen(); });
    }
    setInterval(() => {
      if (document.visibilityState !== 'visible') return;
      sekunden++;
      if (test ? sekunden >= 1 : sekunden >= +d.sekunden && tiefe() >= +d.scroll / 100) zeigen();
    }, 1000);
    // ponytail: Wer mitten in der Nachfrage den Tab wechselt, liefert nur die Hauptantwort. Zweite Sendung mit ID erst, wenn das in den Daten auffällt.
    addEventListener('pagehide', senden);
    document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') senden(); });
  }

  const alle = (wurzel, imEditorZeigen) => (wurzel || document).querySelectorAll('.sn-umf').forEach(el => start(el, imEditorZeigen));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => alle());
  else alle();
  document.addEventListener('shopify:section:load', e => alle(e.target, true));
})();

  } catch(e) { console.error(e); }
})();
})();
